import { moduleFactory } from "@/factories/module";
import { approveOAuthConsent, denyOAuthConsent } from "@/modules/oauth/consent";

export const oauthModule = moduleFactory.create({
  approveOAuthConsent: approveOAuthConsent,
  denyOAuthConsent: denyOAuthConsent,
});
